import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const Footer = () => {
        const [searchParams] = useSearchParams();
        const customerId = searchParams.get("customer_id");
        const token = searchParams.get("token");
        return (
                <footer id="footer" className="bg-white/80 backdrop-blur-sm border-t border-gray-100 px-4 sm:px-8 py-6">
                        <div className="max-w-7xl mx-auto flex flex-wrap justify-center sm:justify-between items-center gap-y-4">
                                <div className="flex flex-wrap justify-center items-center space-x-6">
                                        <div className="text-sm text-text-weak text-center sm:text-left">
                                                © {new Date().getFullYear()} Cleverplant. All rights reserved.
                                        </div>
                                        <div className="hidden sm:flex items-center space-x-4 text-sm text-text-weak">
                                                <Link to="/privacy-policy" className="hover:text-brand transition-colors cursor-pointer">Privacy Policy</Link>
                                                <Link to="/terms-of-service" className="hover:text-brand transition-colors cursor-pointer">Terms of Service</Link>
                                                <Link to={`/support`} className="hover:text-brand transition-colors cursor-pointer">Support</Link>
                                        </div>
                                </div>
                                <div className="flex justify-center sm:justify-start items-center space-x-4">
                                        <div className="text-sm text-text-weak">System Status:</div>
                                        <div className="flex items-center space-x-2">
                                                <div className="w-2 h-2 bg-status-ok rounded-full"></div>
                                                <span className="text-sm font--medium text-status-ok">Operational</span>
                                        </div>
                                </div>
                        </div>
                </footer>
        );
};

export default Footer;
